module.exports = __webpack_public_path__ + "static/section_notice_1-ba4b5edfb296af02bbdbb390a094d345.png";